var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "lexical-editor" }, [
    _c("div", {
      ref: "editorRoot",
      staticClass: "lexical-editor__root",
      attrs: {
        contenteditable: "true",
        role: "textbox",
        spellcheck: "true",
        tabindex: "0",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }